module.exports = __webpack_public_path__ + "media/images/gallery/constellations/equuleus/equ_lines-a395569c6a91edfae48e33d1465b0acf.gif";